import { EdgeCase } from "@/components";
import { NewIntakeLayout } from "@/layout";
import { PATIENT_STATUS } from "@/utils";

export const ActivePatient = () => {
  return (
    <NewIntakeLayout isEdgeCaseScreen>
      <EdgeCase
        status={PATIENT_STATUS.ACTIVE}
        description={
          "This patient is already Active in our system. Please transfer to Patient Customer Support."
        }
      />
    </NewIntakeLayout>
  );
};
